import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GeneralResponse } from 'app/models/general-response.model';
import { environment } from 'environments/environment';
import { catchError, Observable, of, ReplaySubject, tap } from 'rxjs';

export interface SitesMap {
    cfms_code: string;
    codes: string[];
}

@Injectable({
    providedIn: 'root',
})
export class SiteService {
    /**
     * Objects
     */
    private _sites: ReplaySubject<any> = new ReplaySubject<any>(1);
    private _allSitesList: string[] = [];

    /**
     * Constructord
     * @param _http
     */
    constructor(private _http: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * getter for farms
     */
    get sites$(): Observable<any> {
        return this._sites.asObservable();
    }

    /**
     * getter for total sites
     */
    get allSitesList(): string[] {
        return this._allSitesList;
    }

    /**
     * setter for total sites
     */
    set allSitesList(lst: string[]) {
        this._allSitesList = lst;
    }

    // -----------------------------------------------------------------------------------------------------
    // Private methods
    // -----------------------------------------------------------------------------------------------------

    // -----------------------------------------------------------------------------------------------------
    // Public methods
    // -----------------------------------------------------------------------------------------------------

    getSites(): Observable<GeneralResponse> {
        return this._http
            .get<GeneralResponse>(
                `${environment.backendURL}${environment.SiteListURL}`
            )
            .pipe(
                tap((sites) => {
                    this._sites.next(sites.workload.codes);
                    this.allSitesList = sites.workload.codes;
                }),
                catchError((err) => {
                    // return of(null);
                    let customResponse = {} as GeneralResponse;
                    customResponse = {
                        code: err.status,
                        msg: 'Could not load data',
                    };
                    return of(customResponse);
                })
            );
    }
}
